import type { FC } from 'react'
import { RhymeSearchInput } from './RhymeSearchInput'

interface WorksheetHeaderProps {
  searchTerm: string
  onSearchChange: (term: string) => void
  onClear: () => void
  onSubmit?: () => void
  rhythmicStability?: number
}

/**
 * Header component for the exploration worksheet panel
 * Contains search input and stability indicator
 */
export const WorksheetHeader: FC<WorksheetHeaderProps> = ({
  searchTerm,
  onSearchChange,
  onClear,
  onSubmit,
  rhythmicStability
}) => {
  return (
    <div
      data-testid="worksheet-header"
      className="flex flex-col gap-2 p-4 border-b border-gray-200 bg-white"
    >
      {/* Search Input - now using RhymeSearchInput with debounce */}
      <RhymeSearchInput
        value={searchTerm}
        onChange={onSearchChange}
        onSubmit={onSubmit}
        onClear={onClear}
        placeholder="Search word..."
      />

      {/* Stability Indicator */}
      {rhythmicStability !== undefined && (
        <div
          data-testid="worksheet-stability-indicator"
          className="flex items-center gap-2 text-xs text-gray-600"
        >
          <span className="font-medium">Stability:</span>
          <span className="font-mono">{rhythmicStability.toFixed(1)}</span>
        </div>
      )}
    </div>
  )
}
